import { useQuery } from '@tanstack/react-query'

import { getFreeeConnectedUser } from '@src/api'
import { DefaultApiGetFreeeConnectedUserRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts/react-query-cache-keys'
import { useAxios } from '@src/hooks'
export const useFetchFreeeConnectedUser = (
  params: DefaultApiGetFreeeConnectedUserRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: !!params.organizationId,
    queryFn: () => getFreeeConnectedUser(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_FREEE_CONNECTED_USER,
      params.organizationId,
    ],
  })
}
